/**
 * @generated SignedSource<<0856d337466681862330fe5c845fc08c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type FileCollectionItem_File$data = {
  readonly id: string;
  readonly name: string | null;
  readonly type: FileType | null;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"FileIcon_File">;
  readonly " $fragmentType": "FileCollectionItem_File";
};
export type FileCollectionItem_File$key = {
  readonly " $data"?: FileCollectionItem_File$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileCollectionItem_File">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileCollectionItem_File",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIcon_File"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "e5e6b6ee931db8e1d741a8f35d44a9b9";

export default node;
